module.exports = __webpack_public_path__ + "img/arrowToggle.12fdafe4.svg";